import React, { FunctionComponent } from 'react';
import { FormLabel, Input, Text, FormControl, FormErrorMessage } from '@chakra-ui/react';

export interface DateParams {
  id: string;
  title: string;
  message: string | null;
  disabled: boolean;
  value: string;
  name: string;
  placeholder: string;
}

interface DateProps {
  id: string;
  name: string;
  message: string | null;
  title: string;
  value: string;
  body?: string;
  help?: string;
  disabled: boolean;
  placeholder: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function today(): string {
  const dtToday = new Date();

  let month: number | string = dtToday.getMonth() + 1;
  let day: number | string = dtToday.getDate();
  const year = dtToday.getFullYear();

  if (month < 10) month = '0' + month.toString();
  if (day < 10) day = '0' + day.toString();

  return year + '-' + month + '-' + day;
}

const BtDate: FunctionComponent<DateProps> = ({
  id,
  message,
  value,
  onChange,
  body,
  help,
  disabled,
  placeholder,
  title,
}) => {
  return (
    <>
      <FormControl isInvalid={message !== ''}>
        <FormLabel htmlFor={id}>{title}</FormLabel>
        <Text>{help}</Text>
        <Input
          variant='outline'
          color='white'
          border='1px solid'
          borderColor='brand.500'
          _focus={{ color: 'none', bg: 'none', borderColor: 'brand.500' }}
          _hover={{ color: 'none', bg: 'none', borderColor: 'brand.500' }}
          type='date'
          id={id}
          name={id}
          onChange={(event) => onChange(event)}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          min={today()}
        />
        <FormErrorMessage>{message}</FormErrorMessage>
        <Text>{body}</Text>
      </FormControl>
    </>
  );
};

export default BtDate;
